import Splide from '@splidejs/splide';
import { SlideNumber } from './slideNumber.js';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import '@splidejs/splide/css';

document.addEventListener( 'DOMContentLoaded', () => {

  // トップページItemsセクション
  const splideSecItems = document.getElementById( 'splideSecItems' );
  if ( splideSecItems ) {
    const splideItems = new Splide( '#splideSecItems', {
      rewind: false,
      autoplay: false,
      arrows: true,
      pagination: false,
      lazyLoad: 'sequential',
      mediaQuery: 'min',
      perMove: 1,
      autoWidth: true,
      gap: '8vw',
      omitEnd: true,
      breakpoints: {
        768: {
          gap: '3vw',
        },
      }
    });
    splideItems.on( 'overflow', function ( isOverflow ) {
      splideItems.options = {
        arrows    : isOverflow,
        drag      : isOverflow,
      };
    } );
    splideItems.mount({
      SlideNumber,
    });
  }

  // トップページFeatureセクション
  const splideSecFeature = document.getElementById( 'splideSecFeature' );
  if ( splideSecFeature ) {
    const splideFeature = new Splide( '#splideSecFeature', {
      rewind: false,
      autoplay: false,
      arrows: true,
      pagination: false,
      lazyLoad: 'sequential',
      mediaQuery: 'min',
      perMove: 1,
      autoWidth: true,
      gap: '8vw',
      omitEnd: true,
      breakpoints: {
        768: {
          gap: '3vw',
        },
      }
    });
    splideFeature.on( 'overflow', function ( isOverflow ) {
      splideFeature.options = {
        arrows    : isOverflow,
        drag      : isOverflow,
      };
    } );
    splideFeature.mount({
      SlideNumber,
    });
  }

  // トップページServiceセクション
  const splideSecService = document.getElementById( 'splideSecService' );
  if ( splideSecService ) {
    const splideService = new Splide( '#splideSecService', {
      rewind: false,
      autoplay: false,
      arrows: true,
      pagination: false,
      lazyLoad: 'sequential',
      mediaQuery: 'min',
      perMove: 1,
      autoWidth: true,
      gap: '10px',
      omitEnd: true,
      breakpoints: {
        768: {
          gap: '12px',
        },
      }
    });
    splideService.on( 'overflow', function ( isOverflow ) {
      splideService.options = {
        arrows    : isOverflow,
        drag      : isOverflow,
      };
    } );
    splideService.mount({
      SlideNumber,
    });
  }

  // トップページCoordinateセクション
  const splideSecCoordinate = document.getElementById( 'splideSecCoordinate' );
  if ( splideSecCoordinate ) {
    const splideCoordinate = new Splide( '#splideSecCoordinate', {
      type: 'loop',
      rewind: false,
      autoScroll: {
        pauseOnHover: false,
        speed: 0.5,
      },
      arrows: false,
      pagination: false,
      lazyLoad: 'sequential',
      mediaQuery: 'min',
      autoWidth: true,
      gap: '10px',
      breakpoints: {
        768: {
          gap: '12px',
        },
      }
    });
    splideCoordinate.mount({ AutoScroll });
  }

  const splidePlanHairset = document.getElementById( 'splidePlanHairset' );
  if ( splidePlanHairset ) {
    const splideHairset = new Splide( '#splidePlanHairset', {
      rewind: false,
      autoplay: false,
      arrows: true,
      pagination: false,
      lazyLoad: 'sequential',
      mediaQuery: 'min',
      perMove: 1,
      autoWidth: true,
      gap: '10px',
      omitEnd: true,
      breakpoints: {
        1152: {
          gap: '5%',
        },
      }
    });
    splideHairset.on( 'overflow', function ( isOverflow ) {
      splideHairset.options = {
        arrows    : isOverflow,
        drag      : isOverflow,
      };
    } );
    splideHairset.mount({
      SlideNumber,
    });
  }


});
